import React from 'react';
import { Col } from 'antd';
import { DataTable } from 'components';
import { useSelector } from 'react-redux';
import styles from './SubTabPlan2.module.scss';

const SubTabPlan2 = () => {

  const fundingScheme = useSelector(state => state.forms?.carrier?.fundingScheme);
  const fundingPrograms = useSelector(state => state.forms?.carrier?.fundingPrograms);

   const columnsFundingScheme =  [
    {
      title: 'Συνολικός Προϋπολογισμός ΕΣ',
      dataIndex: 'label',
      key: 'label',
       width: 300,
    },
    {
      title: '% Ποσοστό',
      dataIndex: 'percentage',
      key: 'percentage',
      align: 'center',
      width: 240,
      render: value => `${value}%`,
    },
    {
      title: 'Ποσό σε €',
      dataIndex: 'amount',
       width: 200,
      key: 'amount',
      align: 'right',
      render: value =>
        value?.toLocaleString('el-GR', {
          style: 'currency',
          currency: 'EUR',
        }),
    },
  ];

  const dataSourceFundingScheme = [
    {
      key: 'subsidy',
      label: 'Επιδότηση',
      percentage: fundingScheme.subsidy.percentage,
      amount: fundingScheme.subsidy.amount,
    },
    {
      key: 'participation',
      label: 'Ίδια Συμμετοχή',
      percentage: fundingScheme.participation.percentage,
      amount: fundingScheme.participation.amount,
    },
    {
      key: 'loan',
      label: 'Τραπεζικός Δανεισμός',
      percentage: fundingScheme.loan.percentage,
      amount: fundingScheme.loan.amount,
    },
    {
      key: 'total',
      label: 'Σύνολο',
      percentage: fundingScheme.total.percentage,
      amount: fundingScheme.total.amount,
      isTotal: true,
    },
  ];

  const columnsPrograms = [
     {
      title: 'Επιλεγμένα Προγράμματα',
      dataIndex: 'title',
      key: 'title',
      align: 'left',
      width: 300,
      render: value =>
        <span className={styles['badge-program']}>{value}</span>
    },
    {
      dataIndex: 'fundingAmount',
      key: 'fundingAmount',
      align: 'right',
      width: 240,
      render: value =>
        value?.toLocaleString('el-GR', {
          style: 'currency',
          currency: 'EUR',
        }),
    },
  ];

  const dataSourcePrograms = fundingPrograms.map((p, index) => ({
    ...p,
    key: index,
  }));

  return (
    <div style={{minHeight: 800}}>
       <div className={styles.subTabPlan2Form}>
            <p className="mt-4 mr-0 color-purple-3 text-bold font-size-24">
              Χρηματοδοτικά Προγράμματα
            </p>
              <Col span={24}>
                <div>
                  <DataTable
                    scroll={{ x: true }}
                    id="basicInfo-application-results-table"
                    className={styles['table-purple']}                    
                    columns={columnsFundingScheme}
                    dataSource={dataSourceFundingScheme}
                    rowKey="id"
                    pagination={false}
                  />
                </div>
              </Col>
                <div>
                  <DataTable
                    scroll={{ x: true }}
                    id="basicInfo-application-results-table"
                    className={styles['table-purple']}
                    columns={columnsPrograms}
                    dataSource={dataSourcePrograms}
                    rowKey="id"
                    pagination={false}
                    footer={null}
                  />
                </div>
              </div>
     
    </div>
  );
};

export default SubTabPlan2;
